export class SearchByListParameter {
  constructor(
    public key: string = "SupplierPID",
    public list : string = ""
  ) { }
}
